export enum AuthStatus {
	UNKNOWN = 'UNKNOWN', // Initial state, haven't checked yet
	LOADING = 'LOADING', // Checking authentication
	AUTHENTICATED = 'AUTHENTICATED', // Successfully logged in
	UNAUTHENTICATED = 'UNAUTHENTICATED', // Not logged in or failed
	SESSION_EXPIRED = 'SESSION_EXPIRED', // Session expired
	ERROR = 'ERROR', // Authentication error
}
